import { ModelEntityType } from '@upright/common/model/input/types';
import { SdgDrillDownTableRow } from '@upright/common/model/output/scores/sdg-alignment/api-types';
import { SdgAlignmentValence, SdgId } from '@upright/common/model/output/scores/sdg-alignment/types';
import { BouLink } from '@upright/ui/common/generic/content/texts/bou-link';
import { sdgLensSelectionState } from '@upright/ui/common/upright/core/impact-lenses/sdg/selection-state';
import { getModelEntityUrl } from '@upright/ui/untidy/urls';
import styled from 'styled-components';

interface Props {
  data: SdgDrillDownTableRow;
  hasProductAccess: boolean;
  valence: SdgAlignmentValence;
  sdgId: SdgId;
}

export function NameCell(props: Props) {
  const { type, id, name } = props.data;
  const showLink = type !== ModelEntityType.PRODUCT || props.hasProductAccess;
  if (!showLink) {
    return <Root>{name}</Root>;
  }
  const url = `${getModelEntityUrl(type, id, name)}?lens=sdgs&sdgs=${sdgLensSelectionState.serializeSelectionState({
    valence: props.valence,
    sdg: props.sdgId,
  })}`;
  return (
    <Root title={name}>
      <BouLink to={url}>{name}</BouLink>
    </Root>
  );
}

const Root = styled.div`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;
